import React from "react";
export function AppsListIcon(props) {
  return props.type === "home" ? (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="48" height="48" rx="11" fill="#131313" fillOpacity="0.8" />
      <path
        d="M15 21L24 14L33 21V32C33 32.5304 32.7893 33.0391 32.4142 33.4142C32.0391 33.7893 31.5304 34 31 34H17C16.4696 34 15.9609 33.7893 15.5858 33.4142C15.2107 33.0391 15 32.5304 15 32V21Z"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21 34V24H27V34"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ) : props.type === "events" ? (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_430_1569)">
        <path
          d="M20.0015 3H4.00146C2.8969 3 2.00146 3.89543 2.00146 5V15C2.00146 16.1046 2.8969 17 4.00146 17H20.0015C21.106 17 22.0015 16.1046 22.0015 15V5C22.0015 3.89543 21.106 3 20.0015 3Z"
          stroke="white"
          strokeWidth="2.004"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8.00146 21H16.0015"
          stroke="white"
          strokeWidth="2.004"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12 17V21"
          stroke="white"
          strokeWidth="2.004"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_430_1569">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ) : props.type === "ai" ? (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_430_1551)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.59592 2.63963C8.59592 2.93785 8.5191 3.21813 8.38416 3.46175L10.0239 5.40664H13.7706L15.4104 3.46175C15.2755 3.21813 15.1986 2.93785 15.1986 2.63963C15.1986 1.70119 15.9594 0.94043 16.8978 0.94043C17.8362 0.94043 18.5969 1.70119 18.5969 2.63963C18.5969 3.57807 17.8362 4.33882 16.8978 4.33882L16.8934 4.33882L15.9931 5.40664H17.8098C19.7649 5.40664 21.3498 6.99152 21.3498 8.94656V18.8587C21.3498 20.8137 19.7649 22.3986 17.8099 22.3986H6.19931C4.24427 22.3986 2.65939 20.8137 2.65939 18.8587V8.94656C2.65939 6.99152 4.24427 5.40664 6.19931 5.40664H7.80143L6.90112 4.33882L6.8968 4.33882C5.95839 4.33882 5.19767 3.57807 5.19767 2.63963C5.19767 1.70119 5.95839 0.94043 6.8968 0.94043C7.8352 0.94043 8.59592 1.70119 8.59592 2.63963ZM17.8098 7.1058H6.19931C5.18269 7.1058 4.35855 7.92994 4.35855 8.94656V18.8587C4.35855 19.8753 5.18269 20.6994 6.19931 20.6994H17.8099C18.8265 20.6994 19.6506 19.8753 19.6506 18.8587V8.94656C19.6506 7.92994 18.8265 7.1058 17.8098 7.1058ZM8.59914 12.9439C9.53754 12.9439 10.2983 12.1831 10.2983 11.2447C10.2983 10.3063 9.53754 9.54551 8.59914 9.54551C7.66074 9.54551 6.90002 10.3063 6.90002 11.2447C6.90002 12.1831 7.66074 12.9439 8.59914 12.9439ZM17.0951 11.2447C17.0951 12.1831 16.3344 12.9439 15.396 12.9439C14.4576 12.9439 13.6969 12.1831 13.6969 11.2447C13.6969 10.3063 14.4576 9.54551 15.396 9.54551C16.3344 9.54551 17.0951 10.3063 17.0951 11.2447ZM7.74961 16.0225C7.28039 16.0225 6.90002 16.4028 6.90002 16.8721C6.90002 17.3413 7.28039 17.7217 7.74961 17.7217H16.2452C16.7144 17.7217 17.0948 17.3413 17.0948 16.8721C17.0948 16.4028 16.7144 16.0225 16.2452 16.0225H7.74961ZM0.956266 9.33211C1.48413 9.33211 1.91204 9.76003 1.91204 10.2879V14.5359C1.91204 15.0637 1.48413 15.4917 0.956266 15.4917C0.428405 15.4917 0.000488281 15.0637 0.000488281 14.5359V10.2879C0.000488281 9.76003 0.428405 9.33211 0.956266 9.33211ZM23.9995 10.2879C23.9995 9.76003 23.5716 9.33211 23.0438 9.33211C22.5159 9.33211 22.088 9.76003 22.088 10.2879V14.5359C22.088 15.0637 22.5159 15.4917 23.0438 15.4917C23.5716 15.4917 23.9995 15.0637 23.9995 14.5359V10.2879Z"
          fill="#8C8E95"
        />
      </g>
      <defs>
        <clipPath id="clip0_430_1551">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ) : props.type === "leads" ? (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.4001 10.7956C2.4001 9.67959 2.83902 8.60931 3.6203 7.82019C4.40159 7.03107 5.46124 6.58775 6.56614 6.58775H10.1888C10.2341 6.58775 14.9707 6.54201 19.5171 2.70008C19.7018 2.54348 19.9269 2.44335 20.166 2.41143C20.4051 2.37951 20.6483 2.41714 20.867 2.51989C21.0857 2.62265 21.2708 2.78626 21.4006 2.99154C21.5305 3.19683 21.5997 3.43526 21.6001 3.67886V17.9123C21.6013 18.1566 21.5327 18.3962 21.4026 18.6022C21.2725 18.8082 21.0864 18.972 20.8665 19.074C20.6994 19.1533 20.5168 19.1939 20.3322 19.1929C20.0336 19.1931 19.7447 19.0861 19.5171 18.8911C15.8854 15.8175 12.1088 15.1772 10.7322 15.04V18.452C10.7333 18.6633 10.6826 18.8717 10.5846 19.0584C10.4866 19.2451 10.3444 19.4045 10.1707 19.5222L9.17443 20.19C8.96303 20.3254 8.71832 20.3983 8.46802 20.4004C8.31342 20.4005 8.16006 20.3726 8.01519 20.3181C7.82335 20.2459 7.65199 20.1272 7.51618 19.9725C7.38037 19.8178 7.28427 19.6318 7.23632 19.4308L6.14047 14.9851C5.11481 14.8766 4.16518 14.3886 3.47456 13.6151C2.78394 12.8415 2.40121 11.8372 2.4001 10.7956ZM20.2144 18.0586C20.2422 18.0811 20.2759 18.0948 20.3113 18.0981C20.3468 18.1013 20.3823 18.094 20.4137 18.0769C20.4445 18.0625 20.4705 18.0392 20.4882 18.0099C20.5059 17.9806 20.5147 17.9466 20.5133 17.9123V3.67886C20.5147 3.64454 20.5059 3.61059 20.4882 3.58128C20.4705 3.55198 20.4445 3.52864 20.4137 3.5142L20.3322 3.49591C20.3105 3.49525 20.2889 3.49896 20.2687 3.50681C20.2485 3.51466 20.2301 3.52651 20.2144 3.54165C16.2386 6.90791 12.1722 7.53908 10.7322 7.658V13.9331C12.1722 14.0521 16.2386 14.6832 20.2144 18.0586ZM8.29595 19.1655C8.303 19.1934 8.31648 19.2192 8.33529 19.2409C8.35409 19.2625 8.3777 19.2794 8.40418 19.2901C8.43066 19.3008 8.45927 19.305 8.48767 19.3024C8.51608 19.2999 8.54348 19.2905 8.56764 19.2752L9.56387 18.6075C9.5893 18.5906 9.6101 18.5675 9.62435 18.5403C9.63859 18.5131 9.64583 18.4827 9.64538 18.452V15.0034H7.26349L8.29595 19.1655ZM6.56614 13.9057H9.64538V7.68544H6.56614C5.74947 7.68544 4.96625 8.01311 4.38878 8.59637C3.81131 9.17964 3.48689 9.97071 3.48689 10.7956C3.48689 11.6204 3.81131 12.4115 4.38878 12.9948C4.96625 13.578 5.74947 13.9057 6.56614 13.9057Z"
        fill="#8C8E95"
        stroke="#8C8E95"
        strokeWidth="0.72"
      />
    </svg>
  ) : props.type === "courses" ? (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="48" height="48" rx="11" fill="#131313" fillOpacity="0.8" />
      <g clipPath="url(#clip0_346_70972)">
        <path
          d="M16 31.5C16 30.837 16.2634 30.2011 16.7322 29.7322C17.2011 29.2634 17.837 29 18.5 29H32"
          stroke="white"
          strokeWidth="2.004"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M18.5 14H32V34H18.5C17.837 34 17.2011 33.7366 16.7322 33.2678C16.2634 32.7989 16 32.163 16 31.5V16.5C16 15.837 16.2634 15.2011 16.7322 14.7322C17.2011 14.2634 17.837 14 18.5 14V14Z"
          stroke="white"
          strokeWidth="2.004"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_346_70972">
          <rect
            width="24"
            height="24"
            fill="white"
            transform="translate(12 12)"
          />
        </clipPath>
      </defs>
    </svg>
  ) : props.type === "videos" ? (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="48" height="48" rx="11" fill="#131313" fillOpacity="0.8" />
      <path
        d="M18.4797 16.2948C18.4797 15.6558 19.1919 15.2747 19.7235 15.6292L31.2813 23.3343C31.7563 23.651 31.7563 24.349 31.2813 24.6656L19.7235 32.3708C19.1919 32.7252 18.4797 32.3441 18.4797 31.7052V16.2948Z"
        stroke="white"
        strokeWidth="2.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ) : props.type === "websites" ? (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="48" height="48" rx="11" fill="#131313" fillOpacity="0.8" />
      <path
        d="M24 34C29.5228 34 34 29.5229 34 24C34 18.4772 29.5228 14 24 14C18.4772 14 14 18.4772 14 24C14 29.5229 18.4772 34 24 34Z"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14 24H34"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M24 14C26.5013 16.7384 27.9228 20.2921 28 24C27.9228 27.708 26.5013 31.2617 24 34C21.4987 31.2617 20.0772 27.708 20 24C20.0772 20.2921 21.4987 16.7384 24 14V14Z"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ) : (
    <></>
  );
}
export default AppsListIcon;
